import { DEFAULT_LOCALE } from "./constants";
import addUtmQueryToHref from "./utm/addUtmQueryToHref";

export const getComparePath = (locale: string) => getPath(locale).compare;

export const getApplicationProcessPath = (
  locale: string,
  subPath?: string,
  query?: Record<string, string>,
  partnerSlug?: string,
): string => {
  let path: string = getComparePath(locale);
  if (partnerSlug) {
    path = `/partner/${partnerSlug}${path}`;
  }
  if (subPath) {
    path = `${path}/${subPath}`;
  }
  return addUtmQueryToHref(path, query);
};

const PATHS = {
  en: {
    learningCenter: "/learning-center",
    article: (slug: string) => `/learning-center/article/${slug}`,
    compare: "/compare",
    careers: "/careers",
    career: (slug: string) => `/careers/${slug}`,
    meeting: "/meeting",
  },
  de: {
    learningCenter: "/learning-center",
    article: (slug: string) => `/learning-center/article/${slug}`,
    compare: "/vergleich",
    careers: "/karriere",
    career: (slug: string) => `/karriere/${slug}`,
    meeting: "/terminbuchung",
  },
} as const;

const getPath = (locale: string) =>
  PATHS[locale as keyof typeof PATHS] ?? PATHS[DEFAULT_LOCALE];
